var map = {
	"./auctions.svg": 1149,
	"./avisos.svg": 867,
	"./capturas.svg": 8390,
	"./efforts.svg": 3579,
	"./especies.svg": 2262,
	"./expirations.svg": 603,
	"./mapas.svg": 3410,
	"./quotas.svg": 1571,
	"./sales.svg": 7427,
	"./seatides.svg": 1513,
	"./tallas.svg": 9461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8297;